import Vue from 'vue'
import Router from 'vue-router'

import store from './store'

import home from './views/home'
import buyPlan from './views/buy-plan.vue'
import dealerContent from './views/dealer-content'
import login from './views/login'
import register from './views/register'
import account from './views/account.vue'
import loginPage from './views/login-page'
import facebookCallback from './views/facebook-callback'
import resetPassword from './views/reset-password'
import emailVerification from './views/email-verification';

Vue.use(Router);

function ifNotAuthenticated(to, from, next) {
    if (!store.getters.isAuthenticated) {
        if (localStorage.getItem(`token`)) {
            store.dispatch(`getCurrentUser`).then(() => {
                if (store.state.user.type === `employee`)
                    next(`/admin`);
                else
                    next(`/dashboard`);
            });
        } else {
            next();
        }
        return;
    }
    next(``);
}

function ifAuthenticated(to, from, next) {
    if (store.getters.isAuthenticated) {
        next();
    } else {
        store.dispatch(`getCurrentUser`)
            .then(() => {
                if (store.getters.isAuthenticated) {
                    next();
                } else {
                    if (to) {
                        localStorage.setItem(`redirect`, to.path);
                    }
                    next(`/login`);
                }
            });
    }
}

export default new Router({
    mode: `history`,
    routes: [
        {
            path: `/`,
            name: `home`,
            component: home,
            beforeEnter: ifAuthenticated
        },
        {
            path: `/content/:dealer?`,
            name: `dealer-content`,
            component: dealerContent,
            beforeEnter: ifAuthenticated
        },
        {
            path: `/account`,
            name: `account`,
            component: account,
            beforeEnter: ifAuthenticated
        },
        {
            path: `/buy-plan/:dealer?`,
            name: `buy-plan`,
            component: buyPlan
        },
        {
            path: `/email/verification/`,
            name: `email-verification`,
            component: emailVerification,
            beforeEnter: ifAuthenticated
        },
        {
            path: `/email/verification/:guid`,
            name: `email-verification-guid`,
            component: login
        },
        {
            path: `/reset-password/:guid`,
            name: `reset-password`,
            component: resetPassword,
            noIndex: true,
            beforeEnter: ifNotAuthenticated
        },
        {
            path: `/register`,
            name: `register`,
            component: register
        },
        {
            path: `/d/:dealer/:sessionId?`,
            name: `d`,
            component: loginPage
        },
        {
            path: `/_=_`,
            name: `facebook-callback`,
            component: facebookCallback,
            beforeEnter: ifAuthenticated
        },
        {
            path: `/login`,
            name: `login`,
            component: login
        }
    ]
})
